import { render } from "./HeaderLogo.vue?vue&type=template&id=9fcf36da"
const script = {}

import exportComponent from "/Users/yourkesa/Downloads/qron_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__